import { Component } from '@angular/core';

@Component({
    selector: 'app-edit-refund-method-landing',
    templateUrl: './edit-refund-method-landing.component.html',
    styleUrls: ['./edit-refund-method-landing.component.scss']
})
export class EditRefundMethodLandingComponent {
}
